import React from "react";
import { useTranslation } from "react-i18next";
////// Mui
import { Grid, Button, Typography } from "@mui/material";

const FileHeader = ({ file, onDelete }) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Grid container item justifyContent='space-between' alignItems='center'>
        <Grid item>
          <Typography noWrap>{file.name}</Typography>
        </Grid>
        <Grid item>
          <Button size='small' onClick={() => onDelete(file)}>
            {t("button.delete")}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default FileHeader;
